export default __webpack_public_path__ + "static/malaysia-a5433180a5c86c2b21cf5fdda64c090c.svg";